// @flow

import colors from '../../styles/colors'

const componentStyles = {
  menu: (base) => ({
    ...base,
    zIndex: 5,
  }),

  indicatorSeparator: (base) => ({
    ...base,
    display: 'none',
  }),

  dropdownIndicator: (base) => ({
    ...base,
    color: colors.light_gray,
    '&:hover': {
      color: colors.black,
    },
    '> svg': {
      width: '15px',
      height: '15px',
    },
  }),

  control: (base, state) => ({
    ...base,
    border: `1px solid ${colors.light_black}`,
    '&:hover': {
      border: `1px solid ${colors.light_black}`,
    },
    background: state.isDisabled ? '#ebebe4' : colors.white,
  }),

  valueContainer: (base) => ({
    ...base,
    minHeight: '46px',
    display: 'flex',
    maxHeight: '55px',
    overflowY: 'auto',
    fontSize: '11px',
  }),

  placeholder: (base) => ({
    ...base,
    fontSize: '24px',
    color: colors.light_black,
  }),

  singleValue: (base) => ({
    ...base,
    fontSize: '14px',
    color: colors.light_black,
  }),
  multipleValue: (base) => ({
    ...base,
    fontSize: '9px',
    color: colors.light_black,
  }),
}

export const inquiryStyles = {
  menu: (base, state) => ({
    ...base,
    zIndex: 5,
  }),
  option: (provided, state) => ({
    ...provided,
    background: state.isSelected && colors.monza,
    '&:hover': {
      background: !state.isSelected && '#eee',
    },
  }),

  indicatorSeparator: (base) => ({
    ...base,
    display: 'none',
  }),

  dropdownIndicator: (base) => ({
    ...base,
    '> svg': {
      width: '15px',
      height: '15px',
    },
  }),

  control: (base, state) => ({
    ...base,
    background: state.isDisabled ? '#ebebe4' : colors.white,
    border: state.isFocused && `1px solid ${colors.monza}`,
    boxShadow: state.isFocused && `0px 0px 0px 1px ${colors.monza};`,
    '&:hover': {
      border: state.isFocused && `1px solid ${colors.monza}`,
    },
  }),

  valueContainer: (base) => ({
    ...base,
    minHeight: '46px',
    display: 'flex',
    maxHeight: '55px',
    overflowY: 'auto',
    fontSize: '11px',
  }),

  placeholder: (base) => ({
    ...base,
    fontSize: '24px',
  }),

  singleValue: (base) => ({
    ...base,
    fontSize: '14px',
    color: colors.light_black,
  }),
  multipleValue: (base) => ({
    ...base,
    fontSize: '9px',
    color: colors.light_black,
  }),
}

export default componentStyles
